/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./row.vue?vue&type=template&id=0cb9b1e8&"
import script from "./row.vue?vue&type=script&lang=ts&"
export * from "./row.vue?vue&type=script&lang=ts&"
import style0 from "./row.vue?vue&type=style&index=0&id=0cb9b1e8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports